import React from "react";
import { useGetLunchPackagesOptions } from "../../../hooks/lunchPackages/lunchPackages.hooks";
import Dropdown from "../../Dropdown/dropdown";
import { getSelectedOptionFromValue } from "../../../Helper/options.helper";

interface IProps {
  onLunchPackageSelect: (selectedLunchPackage: any) => unknown;
  selectedLunchPackageId: number | null;
}

export const LunchPackagesOptions = ({
  onLunchPackageSelect,
  selectedLunchPackageId,
}: IProps) => {
  const { isLoading, data: LUNCH_PACKAGES_OPTIONS } =
    useGetLunchPackagesOptions();

  if (isLoading) return <div />;

  return (
    <Dropdown
      label="Lunch Package"
      options={LUNCH_PACKAGES_OPTIONS || []}
      selectedOption={getSelectedOptionFromValue(
        LUNCH_PACKAGES_OPTIONS || [],
        selectedLunchPackageId
      )}
      setSelectedOption={(option) => {
        onLunchPackageSelect(option);
      }}
      canBeEmpty
    />
  );
};
